export function applyBlurStrokeFilters (apexRef, colors = []) {
  if (!apexRef || !Array.isArray(colors) || colors.length === 0) return

  const chartElement = apexRef.$el || apexRef

  if (!chartElement) return

  const paths = chartElement.querySelectorAll('.apexcharts-series path')

  paths.forEach((path, i) => {
    path.style.filter = `drop-shadow(0 0 2px ${colors[i % colors.length]})`
  })
}
